<template>
  <div>
    <!-- Page Banner -->
    <section class="page-banner bgs-cover overlay pt-50 ban-h ban-m mob-ban" style="background-image: url(/assets/images/contact-us.jpg)">
      <div class="container">
        <div class="banner-inner">
          <h1 class="page-title1">{{ $t('contact.title') }} <span>{{ $t('contact.titleSpan') }}</span></h1>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-page">
      <div class="container">
        <div class="contact-info-area">
          <div class="col-md-6 contact-title">
            <h1>{{ $t('contact.mainTitle') }} <span>{{ $t('contact.mainTitleSpan') }}</span></h1>
          </div>
          <div class="col-md-6 contact-info-item wow fadeInUp delay-0-4s text-centre">
            <i class="far fa-envelope"></i>
            <p><span>{{ $t('contact.emailText') }}</span></p>
            <a href="mailto:contact@opalina.com?subject=Connect with us">
              <button class="contact-btn">{{ $t('contact.emailAddress') }}</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>
